import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { FilterConditionType, FilterState } from '../../types/Spreadsheet';
import { RootState } from '../store';

interface FiltersState {
  filters: FilterState;
}

const initialState: FiltersState = {
  filters: []
};

const filtersSlice = createSlice({
  name: 'filters',
  initialState,
  reducers: {
    setFilters( state, action: PayloadAction<FilterState> ) {
      state.filters = action.payload;
    },
    addFilter( state, action: PayloadAction<FilterConditionType> ) {
      state.filters.push( action.payload );
    },
    removeFilter( state, action: PayloadAction<number> ) {
      state.filters.splice( action.payload, 1 );
    },
    clearFilters( state ) {
      state.filters = [];
    }
  }
});

export const { setFilters, addFilter, removeFilter, clearFilters } = filtersSlice.actions;
export const selectFilters = ( state: RootState ) => state.spreadsheet.filters.filters;
export default filtersSlice.reducer;